function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* istanbul ignore file */
import React, { useLayoutEffect, useState } from 'react';
import { Global } from '@emotion/core';
import themes from '@domain-group/design-tokens/lib/themes';
import { globalStyles } from '../export';
import { jsx as ___EmotionJSX } from "@emotion/core";
var designTokensPackage = require('@domain-group/design-tokens/package.json');
var defaultTheme = process.env.FE_BRARY_THEME;
var designTokensVersion = designTokensPackage.version;
var theme = {
  default: defaultTheme,
  selector: ['body'],
  blurOnSelect: true,
  ignoreQueryParams: false,
  persist: true,
  themes: [{
    id: 'domain',
    title: 'Domain',
    class: 'domain',
    color: '#0EA800'
  }, {
    id: 'domain-2022',
    title: 'Domain 2022',
    class: 'domain',
    color: '#005837'
  }, {
    id: 'cre',
    title: 'CRE',
    class: 'cre',
    color: '#FF5328'
  }, {
    id: 'allhomes',
    title: 'Allhomes',
    class: 'allhomes',
    color: '#E81043'
  }, {
    id: 'pricefinder',
    title: 'Pricefinder',
    class: 'pricefinder',
    color: '#15d99e'
  }, {
    id: 'rta',
    title: 'RTA',
    class: 'rta',
    color: '#B5E9FC'
  }]
};
var actions = {
  argTypesRegex: '^on[A-Z].*'
};
export var useTheme = selectedTheme => {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    currentTheme = _useState2[0],
    setCurrentTheme = _useState2[1];
  useLayoutEffect(() => {
    if (currentTheme !== selectedTheme) {
      var body = document.body;
      body.setAttribute('data-theme-name', selectedTheme);
      setCurrentTheme(selectedTheme);
    }
  }, [selectedTheme, currentTheme]);
  return currentTheme;
};
var decorators = [(Story, context) => {
  var globals = context.globals;
  var selectedTheme = globals.theme || defaultTheme;
  var currentTheme = useTheme(selectedTheme);
  var themeVersion = globals.themeVersion;
  useLayoutEffect(() => {
    // Allow the theme version to be overriden. There's no UI for this yet,
    // but the themeVersion global can be specified in the storybook URL as
    // a `globals` query param, e.g.:
    //   localhost:5000?globals=themeVersion:tokens-branch-name
    // A typical use-case for this will be to use a specific branch of the
    // design-tokens to preview changes in situ. With this in mind, if
    // `themeVersion` doesn't begin with a number we assume it's a branch name.
    var assetPrefix;
    if (themeVersion.match(/^(\d|latest)/)) {
      assetPrefix = "https://s.domainstatic.com.au/design-tokens/".concat(themeVersion, "/css");
    } else if (themeVersion === 'localhost') {
      // Storybook doesn't support 'exotic' characters in query params
      // so we can't support passing a full URL, have to assume that people
      // will run `npx http-server` from design-tokens root
      assetPrefix = "http://localhost:8080/dist/css";
    } else {
      // Important that we not use the CDN hostname when constructing a
      // branch-preview URL. This is because the CDN will have aggressive
      // caching, which isn't ideal when referencing mutable dev assets.
      assetPrefix = "https://domain-static.s3.ap-southeast-2.amazonaws.com/design-tokens/branch-preview/".concat(themeVersion, "/css");
    }
    themes.forEach(_theme => {
      // any attributes included in this selector should also be added to the
      // links injected by previewHead (see storybook-preview-head.js)
      var themeLink = document.head.querySelector("link[rel=stylesheet][data-theme=\"".concat(_theme.name, "\"][data-version=\"").concat(themeVersion, "\"]"));
      var staleThemeLink = document.head.querySelector("link[rel=stylesheet][data-theme=\"".concat(_theme.name, "\"]:not([data-version=\"").concat(themeVersion, "\"])"));
      if (!themeLink) {
        themeLink = document.createElement('link');
        themeLink.setAttribute('rel', 'stylesheet');
        themeLink.setAttribute('href', "".concat(assetPrefix, "/").concat(_theme.name, "-auto.css"));
        themeLink.setAttribute('data-version', themeVersion);
        themeLink.setAttribute('data-theme', _theme.name);
        if (staleThemeLink) {
          themeLink.onload = () => {
            staleThemeLink.remove();
          };
        }
        document.head.appendChild(themeLink);
      }
    });
  }, [themeVersion]);
  return ___EmotionJSX("div", {
    key: currentTheme
  }, ___EmotionJSX(Global, {
    styles: [globalStyles]
  }), ___EmotionJSX(Story, {
    theme: selectedTheme
  }));
}];
var globals = {
  theme: defaultTheme,
  themeVersion: designTokensVersion
};
export default {
  theme,
  actions,
  decorators,
  globals
};